export default "__VITE_ASSET__BsBMchOx__"